import { decryptData, encryptData, getFrontKey } from "./securityService";
import { app } from "../config/const";

const API_BASE_URL = "/api";

export type RequestOptions = {
  headers?: Record<string, string>;
  body?: any;
};

export async function clientFetch(
  endpoint: string,
  method: "GET" | "POST" | "PUT" | "DELETE" = "GET",
  key?: string | null,
  options?: RequestOptions
): Promise<any> {
  const url = `${API_BASE_URL}${endpoint}`;
  const headers = {
    "Content-Type": "application/json",
    "Ryo-Verification": getFrontKey(),
    ...options?.headers,
  };

  let bodyData: any;
  if (options?.body !== undefined && options?.body !== null) {
    const fullOrigin =
      globalThis.location.protocol +
      "//" +
      globalThis.location.host +
      globalThis.location.pathname;
    const dataWithOrigin = {
      ...options.body,
      origin: fullOrigin,
      app: app.Calendar,
    };
    const frontKey = getFrontKey();
    bodyData = key
      ? await encryptData(dataWithOrigin, key)
      : {
          data: dataWithOrigin,
          ...(frontKey ? { key: frontKey } : {}),
        };
  }

  const config: RequestInit = {
    method,
    headers,
    credentials: "include",
  };

  if (method !== "GET") {
    config.body = JSON.stringify(bodyData);
  }

  const response = await fetch(url, config);
  if (response.status !== 200) {
    const text = await response.text();
    let message = "Error en la solicitud";
    try {
      message = JSON.parse(text)?.message || message;
    } catch (e) {
      console.error(e);
    }
    throw new Error(message);
  }

  const encryptedData = await response.json();
  if (!encryptedData.key) {
    return encryptedData;
  }

  return decryptData(encryptedData);
}
